export const XOLogo = ({ compact = false }: { compact?: boolean }) => (
  <div className={`xo-logo${compact ? " xo-logo--compact" : ""}`} aria-label="XO">
    <svg aria-hidden="true" viewBox="0 0 72 72">
      <circle cx="30" cy="30" r="14" />
      <circle className="xo-logo__core" cx="30" cy="30" r="5" />
      <path d="M8 8L62 62M52 8L8 52" />
      <path className="xo-logo__axis" d="M30 6V54M6 30H54" />
    </svg>
    <span>XO</span>
  </div>
);
